var map = {
	"./ChooseWine.png": 97696,
	"./InfoWine.png": 4791,
	"./TastingWine.png": 27105,
	"./abruzzoWOrW350.png": 42530,
	"./abruzzoWW350.png": 30837,
	"./chooseWOrW350.png": 41946,
	"./chooseWW350.png": 18461,
	"./tasteWOrW350.png": 45590,
	"./tasteWW350.png": 11041
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 5009;